import { FC, useEffect, useState } from 'react';
import { Modal, Button, Spin, Tag, message, Form, Input, Divider, Flex } from 'antd';
import { useTranslation } from 'react-i18next';
import { OrderItemV2 } from '@/types/inventoryV2';
import { purOrderInventories } from '@/apis/purchase';
import { ConfirmedEnum, OperateEnum } from '@/types/inventory';
import PrintInventoryV2, { PrintType } from '@/SupplierPages/Home/InventoryOrder/components/PrintInventoryV2';
import { Product } from '@/types/product';

interface PurItemInventoryListProps {
  purItemId: string;
  purOrderNo: string;
  product: Product;
  onClose: () => void;
  onInbound: (orderId: string) => void;
}

const PurItemInventoryList: FC<PurItemInventoryListProps> = ({
  purItemId,
  purOrderNo,
  product,
  onClose,
  onInbound,
}) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState<boolean>(false);
  const [inventoryOrders, setInventoryOrders] = useState<OrderItemV2[]>([]);
  const [printingId, setPrintingId] = useState<string>('');

  // 获取库存订单数据
  useEffect(() => {
    if (purItemId) {
      setLoading(true);
      purOrderInventories(purItemId)
        .then(res => {
          if (res && res.length > 0) {
            setInventoryOrders([...res.map(itm => ({ ...itm, product, }))]);
          }
        })
        .catch(err => {
          message.error(t('common.fetchError'));
          console.error('Failed to fetch inventory orders:', err);
        })
        .finally(() => setLoading(false));
    }
  }, [purItemId]);



  return (
    <Modal
      title={t('warehouse.inventoryOrderList')}
      open={true}
      onCancel={onClose}
      width={800}
      footer={[
        <Button key="close" onClick={onClose}>
          {t('common.cancel')}
        </Button>
      ]}
    >
      <Spin spinning={loading}>
        <div style={{ maxHeight: '600px', overflowY: 'auto' }}>
          {inventoryOrders.map((item) => {
            return (
              <div key={item.id} style={{ border: "1px solid #c6bfbf", borderRadius: 10, padding: '15px 15px', marginBottom: 10 }}>
                <span>{t('purchase.deliveryNumber')}: {item?.order?.number ?? ''}</span>
                <span style={{ marginLeft: 50 }}>
                  {t('purchase.state') + ': '}
                  {
                    item?.order?.confirmState === ConfirmedEnum.CONFIRM ? (
                      item?.order?.opType === OperateEnum.IN_RETURN ?
                        <Tag color="red">{t('purchase.inReturn')}</Tag> :
                        item?.order?.opType === OperateEnum.OUT_RETURN ?
                          <Tag color="green">{t('purchase.cancelReturn')}</Tag> :
                          <Tag color="blue">{t('purchase.inStock')}</Tag>
                    ) :
                      <Tag color="warning">{t('purchase.notInStock')}</Tag>
                  }
                </span>
                <Divider style={{ margin: '5px 0' }} />
                <Form labelCol={{ span: 4 }}>
                  <Form.Item label={t('purchase.goodName')} name={'typeName'} initialValue={item?.product?.name}>
                    <Input disabled />
                  </Form.Item>
                  <Form.Item label={t('purchase.goodCode')} name={'typeCode'} initialValue={item?.product?.code || ''}>
                    <Input disabled />
                  </Form.Item>
                  <Form.Item label={t('purchase.goodModel')} name={'type'} initialValue={item?.product?.model || ''}>
                    <Input disabled />
                  </Form.Item>
                  <Form.Item label={t('purchase.quantity')} name={'num'} initialValue={item.count}>
                    <Input disabled />
                  </Form.Item>
                </Form>
                <Flex justify="end" gap={10}>
                  <PrintInventoryV2 printType={PrintType.PURCHASE} purOrderNo={purOrderNo}
                    onStart={() => setPrintingId(item.id)}
                    onEnd={() => setPrintingId('')}
                    selectedRows={[item]}
                    disabled={!!printingId && printingId !== item.id}
                  />
                  <Button type="primary" onClick={() => onInbound(item.orderId)} >{t('sale.inStock')}</Button>
                </Flex>
              </div>
            )
          })}
        </div>
      </Spin>
    </Modal>
  );
};

export default PurItemInventoryList;